import { styled } from "@mui/material/styles";
import { Box, Grid2, Typography } from "@mui/material";

export const RootBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const ContentGrid = styled(Grid2)(({ theme }) => ({
  marginTop: theme.spacing(4),
}));

export const SectionTitleTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: "bold",
  fontSize: "18px",
  color: theme.palette.text.primary,
  [theme.breakpoints.down("md")]: {
    fontSize: "16px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));
